export const formatBytes = (bytes?: number | null, decimals = 1): string => {
  if (!bytes || bytes <= 0) return '0 B';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const value = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
  return `${value} ${sizes[i]}`;
};

export const getFileExtension = (fileName: string): string => {
  const parts = fileName.split('.');
  if (parts.length <= 1) return '';
  return parts.pop()!.toLowerCase();
};

export const formatCategoryLabel = (category: string): string => {
  if (!category) return '';
  return category
    .replace(/[-_]+/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
